import React from "react";
import styles from "./TableHeaderRow.module.css";

export const TableHeaderRow = props => (
  <tr {...props} className={[styles.Row, props.className].join(" ")} />
);
